import { render, staticRenderFns } from "./coupon-list.vue?vue&type=template&id=f593a5fe&scoped=true"
import script from "./coupon-list.vue?vue&type=script&lang=js"
export * from "./coupon-list.vue?vue&type=script&lang=js"
import style0 from "./coupon-list.vue?vue&type=style&index=0&id=f593a5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f593a5fe",
  null
  
)

export default component.exports